<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(module.id)" v-if="$can('module-delete') && module.id" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="module.name"
                  v-model="module.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('modules.name')"
                  :error-messages="errors.collect('module.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="module.price"
                  v-model="module.price"
                  class="required-field"
                  v-validate="'required|numeric'"
                  :label="$t('modules.price')"
                  :error-messages="errors.collect('module.price')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ModuleForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      module: {},

      dictionary: {
        attributes: {
          "module.name": this.$t("modules.name"),
          "module.price": this.$t("modules.price"),
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.module, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.module))
      this.setPageTitle()
    } else {
      this.title = this.$t("modules.edit_module")

      axios
        .get(this.API_URL + "module/" + this.id)
        .then((res) => {
          this.module = res.data.data
          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.module))
          this.setPageTitle()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setPageTitle() {
      if (_.has(this.module, "id")) {
        this.page_title = this.$t("modules.edit_module", {
          name: this.module.name
        })
      } else {
        this.page_title = this.$t("modules.new_module")
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.module.id) {
              // Create
              axios
                .post(this.API_URL + "module", {
                  name: this.module.name,
                  price: this.module.price,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.module = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.module))
                      vm.setPageTitle()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/modules/edit/${vm.module.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "module", {
                  id: this.module.id,
                  name: this.module.name,
                  price: this.module.price,
                })
                .then((res) => {
                  vm.module = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.module))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "module/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/modules")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
